import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { AuthLayout } from '../components/AuthLayout';
import { Button } from '../components/Button';
import { Input } from '../components/Input';

export function SignupPage() {
  const { signUp } = useAuth();
  const navigate = useNavigate();
  const [displayName, setDisplayName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [authorizationCode, setAuthorizationCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await signUp(email, password, displayName, authorizationCode);
      navigate('/clients', { replace: true });
    } catch (err) {
      // Cognito wraps PRE_SIGN_UP trigger errors as "PreSignUp failed with
      // error <msg>."; show just the message.
      const raw = (err as Error).message;
      const match = raw.match(/PreSignUp failed with error (.*?)\.?$/);
      setError(match ? match[1] : raw);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout
      title="Create your account"
      footer={<>Already have an account? <Link className="text-hs-primary font-semibold" to="/login">Sign in</Link></>}
    >
      <form onSubmit={onSubmit} className="flex flex-col gap-4">
        <Input label="Name" type="text" value={displayName} onChange={(e) => setDisplayName(e.target.value)} required />
        <Input label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <Input
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          minLength={8}
          required
        />
        <Input
          label="Authorization code"
          type="text"
          value={authorizationCode}
          onChange={(e) => setAuthorizationCode(e.target.value)}
          autoComplete="off"
          required
        />
        {error && <p role="alert" className="text-[13px] text-hs-danger-text">{error}</p>}
        <Button type="submit" loading={submitting} fullWidth>
          {submitting ? 'Creating account…' : 'Sign up'}
        </Button>
      </form>
    </AuthLayout>
  );
}
